module.exports = __webpack_public_path__ + "media/images/menu/ophiuchus-b21ec2fe7a93c8d0f2de387d8127f2cf.jpg";